import React from "react";
import CustomInput from "../../../components/CustomForm/CustomInput";
import {
  FormWrapper,
  Form,
  FormGroup,
} from "../../../components/CustomForm/FormStyles";
import useEmpresa from "../../../hooks/useEmpresa";
import CustomIconInput from "../../../components/CustomForm/CustomIconInput";
import { Avatar } from "../../../components/Common/CommonStyles";
import Colors from "../../../themes/Colors";
import Tooltip from "../../../components/Common/Tooltip";
import CustomIcon from "../../../components/Common/CustomIcon";
import { SearchOutlined, DeleteOutlined } from "@ant-design/icons";
import CustomSelect from "../../../components/CustomForm/CustomSelect";
import {
  TIPO_DOCUMENTO_OPTIONS,
  MAXIMO_CARATERES_DOCUMENTO,
  TIPO_DOCUMENTO_CORE,
} from "../../../utils/LocalData";
import CheckRender from "../../../components/Common/CheckRender";
import CustomCheckbox from "../../../components/CustomForm/CustomCheckbox";

const AfiliadoForm = ({
  queryAfiliado,
  queryDocumento,
  cedula,
  nss,
  nombres,
  apellidos,
  edad,
  tipoDocumento,
  foto,
  onStateChange,
  onSearch,
  onSearchDocumento,
  onClean,
  onQueryAfiliadoChange,
  onQueryDocumentoChange,
  esPilotoSam,
  esSuplementario,
  disabled,
}) => {
  const empresa = useEmpresa();

  return (
    <FormWrapper
      flexDirection={"row"}
      flex={"1"}
      borderColor={empresa?.COLOR_PRINCIPAL}
    >
      <FormWrapper borderColor={Colors.transparent} maxWidth={"100px"}>
        <Avatar src={foto} />
      </FormWrapper>

      <FormWrapper borderColor={Colors.transparent}>
        <Form>
          <FormGroup>
            <CustomIconInput
              type={"text"}
              width={"150px"}
              placeholder={empresa?.TIPO_CLIENTE}
              label={empresa?.TIPO_CLIENTE}
              value={queryAfiliado}
              position={"absolute"}
              disabled={disabled}
              onChange={onQueryAfiliadoChange()}
              icons={
                <>
                  <Tooltip text="Buscar">
                    <CustomIcon
                      icon={SearchOutlined}
                      style={{ color: empresa?.COLOR_PRINCIPAL, fontSize: 30 }}
                      hoverColor={empresa?.COLOR_SECUNDARIO}
                      onClick={onSearch}
                    />
                  </Tooltip>
                  <Tooltip text="Limpiar">
                    <CustomIcon
                      icon={DeleteOutlined}
                      style={{ color: empresa?.COLOR_PRINCIPAL, fontSize: 30 }}
                      hoverColor={empresa?.COLOR_SECUNDARIO}
                      onClick={onClean}
                    />
                  </Tooltip>
                </>
              }
            />
          </FormGroup>
          <CheckRender allowed={esPilotoSam}>
            <FormGroup>
              <CustomSelect
                options={TIPO_DOCUMENTO_OPTIONS}
                label={"Tipo de Documento"}
                value={tipoDocumento}
                onChange={onStateChange("tipoDocumento")}
                required={false}
                disabled={false}
              />
            </FormGroup>
            <FormGroup>
              <CustomIconInput
                type={"text"}
                width={"150px"}
                placeholder={"Número de Documento"}
                label={"Número de Documento"}
                value={queryDocumento}
                position={"absolute"}
                disabled={disabled}
                onChange={onQueryDocumentoChange()}
                maxLength={
                  tipoDocumento === TIPO_DOCUMENTO_CORE.CEDULA ||
                  tipoDocumento === TIPO_DOCUMENTO_CORE.NUI
                    ? MAXIMO_CARATERES_DOCUMENTO.CEDULA
                    : MAXIMO_CARATERES_DOCUMENTO.DEFAULT
                }
                icons={
                  <>
                    <Tooltip text="Buscar">
                      <CustomIcon
                        icon={SearchOutlined}
                        style={{
                          color: empresa?.COLOR_PRINCIPAL,
                          fontSize: 30,
                        }}
                        hoverColor={empresa?.COLOR_SECUNDARIO}
                        onClick={onSearchDocumento}
                      />
                    </Tooltip>
                    <Tooltip text="Limpiar">
                      <CustomIcon
                        icon={DeleteOutlined}
                        style={{
                          color: empresa?.COLOR_PRINCIPAL,
                          fontSize: 30,
                        }}
                        hoverColor={empresa?.COLOR_SECUNDARIO}
                        onClick={onClean}
                      />
                    </Tooltip>
                  </>
                }
              />
            </FormGroup>
          </CheckRender>
          <CheckRender allowed={!esPilotoSam}>
            <FormGroup>
              <CustomInput
                type={"text"}
                placeholder={"Cédula"}
                label={"Cédula"}
                value={cedula}
                disabled={true}
                onChange={onStateChange("cedula")}
              />
            </FormGroup>
          </CheckRender>
          <FormGroup>
            <CustomInput
              type={"text"}
              placeholder={"NSS"}
              label={"NSS"}
              value={nss}
              disabled={true}
              onChange={onStateChange("nss")}
            />
          </FormGroup>
          <FormGroup>
            <CustomInput
              type={"text"}
              placeholder={"Nombres"}
              label={"Nombres"}
              value={nombres}
              disabled={true}
              onChange={onStateChange("nombres")}
            />
          </FormGroup>
          <FormGroup>
            <CustomInput
              type={"text"}
              placeholder={"Apellidos"}
              label={"Apellidos"}
              value={apellidos}
              disabled={true}
              onChange={onStateChange("apellidos")}
            />
          </FormGroup>
          <FormGroup>
            <CustomInput
              type={"text"}
              placeholder={"Edad"}
              label={"Edad"}
              value={edad}
              disabled={true}
              onChange={onStateChange("edad")}
            />
          </FormGroup>
          <CheckRender allowed={esPilotoSam}>
            <FormGroup>
              <CustomCheckbox
                label={"Plan Suplementario"}
                padding={"25px"}
                checked={esSuplementario}
                disabled={true}
                checkedColor={empresa?.COLOR_PRINCIPAL}
                uncheckedColor={Colors.blueTransparent}
                checkmarkColor={Colors.white}
              />
            </FormGroup>
            <FormGroup />
          </CheckRender>
        </Form>
      </FormWrapper>
    </FormWrapper>
  );
};

export default AfiliadoForm;
